import TokensService from '@omni/kit/services/TokensService';

import BaseService, { IHttpResponse } from '../../BaseService';
import { IPrepareMediaItemUrl, prepareMediaUrl } from '../BuildUrls';
import { IMediaItem } from '../Types';

const debug = require('debug')('tca:service:MediaItemService:Core:GetOne');

interface IMediaItemGetOne extends IPrepareMediaItemUrl {
  appKey?: string;
  id: string;
}

interface IMediaItemGetOneResponse extends IHttpResponse {
  body?: IMediaItem;
}

export default async ({
  appKey,
  ...buildUrlProps
}: IMediaItemGetOne): Promise<IMediaItemGetOneResponse> => {
  debug('GetOne');
  const url = prepareMediaUrl(buildUrlProps);

  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({
    url,
    appKey,
    token: guestToken,
  });
};
